import { useStore } from "@/state/store";
import { Icon } from "@/components/atoms/Icons";

export function NotificationsPopover() {
  const open = useStore((s) => s.notifOpen);
  const setOpen = useStore((s) => s.setNotifOpen);
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-50 bg-black/30 backdrop-blur-sm"
      onClick={() => setOpen(false)}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className="absolute right-4 top-16 w-[340px] rounded-modal border border-line bg-bg-1 p-4 shadow-[var(--shadow-card)]"
      >
        <div className="mb-2 flex items-center justify-between">
          <h3 className="text-[14px] font-semibold">Notifications</h3>
          <button
            className="btn-ghost h-7 w-7 rounded-full p-0"
            onClick={() => setOpen(false)}
          >
            <Icon.X size={14} />
          </button>
        </div>
        <ul className="flex flex-col gap-2 text-[13px] text-text-2">
          <li className="rounded-[10px] border border-line bg-bg-2 p-3">
            Welcome to PredictionLeap. Sign in to start trading.
          </li>
          <li className="rounded-[10px] border border-line bg-bg-2 p-3 text-muted">
            No realtime feed in this build — the WS bus is wired but the
            frontend subscriber lands next round.
          </li>
        </ul>
      </div>
    </div>
  );
}
